var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "collapse collapse-item",
      class: { "is-active": _setup.active },
    },
    [
      _c(
        "div",
        {
          staticClass: "collapse-header touchable",
          attrs: {
            role: "tab",
            "aria-expanded": _setup.active ? "true" : "false",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _setup.toggle.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "collapse-header__title" },
            [_vm._t("header")],
            2
          ),
          _c(
            "div",
            { staticClass: "collapse-header__icon" },
            [
              _setup.active
                ? _c(_setup.SvgIcon, {
                    attrs: { size: "14", type: "mdi", path: _setup.path.close },
                  })
                : _c(_setup.SvgIcon, {
                    attrs: { size: "14", type: "mdi", path: _setup.path.open },
                  }),
            ],
            1
          ),
        ]
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _setup.active
          ? _c("div", { staticClass: "collapse-content" }, [
              _c(
                "div",
                { staticClass: "collapse-content-box" },
                [_vm._t("default")],
                2
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }